import infoBarMessageCreatorsMap from '../utils/infoBarMessageCreatorsMap';
import { action } from 'satcheljs/lib/legacy';
var removeInfoBarMessage = action('removeInfoBarMessage')(function removeInfoBarMessage(viewState, messageIds) {
    if (!viewState.infoBarIds || !viewState.infoBarIds.length) {
        return;
    }
    if (messageIds) {
        messageIds = Array.isArray(messageIds) ? messageIds : [messageIds];
        for (var i = viewState.infoBarIds.length - 1; i >= 0; i--) {
            var messageId = viewState.infoBarIds[i];
            if (messageIds.indexOf(messageId) >= 0) {
                viewState.infoBarIds.splice(i, 1);
                if (infoBarMessageCreatorsMap[viewState.composeId]) {
                    delete infoBarMessageCreatorsMap[viewState.composeId][messageId];
                    if (Object.keys(infoBarMessageCreatorsMap[viewState.composeId]).length === 0) {
                        delete infoBarMessageCreatorsMap[viewState.composeId];
                    }
                }
            }
        }
    }
    else {
        viewState.infoBarIds = [];
        delete infoBarMessageCreatorsMap[viewState.composeId];
    }
});
export default removeInfoBarMessage;
//# sourceMappingURL=removeInfoBarMessage.js.map